import React, { useEffect, useState } from "react";
import API from "../services/api";

const BiddingBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bids, setBids] = useState([]);
  const [expiring, setExpiring] = useState(false);

  const fetchBiddingBookings = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await API.get("/bidding-bookings");
      setBookings(res.data.bookings || []);
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to load bidding bookings");
    } finally {
      setLoading(false);
    }
  };

  const openDetails = async (bookingId) => {
    try {
      setIsModalOpen(true);
      setSelectedBooking(null);
      setBids([]);
      const res = await API.get(`/booking/${bookingId}`);
      if (res.data.success) {
        setSelectedBooking(res.data.booking);
        setBids(res.data.bids || []);
      }
    } catch (err) {
      console.log(err);
    }
  };



    const handleMarkExpired = async (bookingId) => {
    if (!window.confirm("Are you sure you want to mark this booking as Expired?")) return;

    try {
      setExpiring(true);
    
const res = await API.put(`/booking/${bookingId}/mark-expired`);
      if (res.data.success) {
        setIsModalOpen(false);
        fetchBiddingBookings();
        alert("Booking marked as expired.");
      }
    } catch (err) {
      alert(err?.response?.data?.message || "Failed to mark booking as expired");
    } finally {
      setExpiring(false);
    }
  };


  useEffect(() => {
    fetchBiddingBookings();
  }, []);

  if (loading) return <div style={styles.centerScreen}><div style={styles.loader}></div><p>Syncing Live Bids...</p></div>;
  if (error) return <div style={styles.errorState}><h3>⚠️ Error</h3><p>{error}</p><button onClick={fetchBiddingBookings} style={styles.refreshBtn}>Try Again</button></div>;

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>Live Bidding Monitor</h2>
          <p style={styles.subtitle}>Manage and monitor real-time driver negotiations</p>
        </div>
        <button style={styles.refreshBtn} onClick={fetchBiddingBookings}>
          <span style={{ marginRight: "8px" }}>↻</span> Refresh Feed
        </button>
      </div>

      {/* GRID */}
      {bookings.length === 0 ? (
        <div style={styles.emptyCard}>
          <p>No active bidding sessions found at the moment.</p>
        </div>
      ) : (
        <div style={styles.grid}>
          {bookings.map((b) => (
            <div key={b._id} style={styles.card} onClick={() => openDetails(b._id)}>
              <div style={styles.cardTop}>
                <span style={styles.bookingId}>#{b._id.slice(-6).toUpperCase()}</span>
                <span style={styles.statusBadge}>{b.status}</span>
              </div>

              <div style={styles.routeContainer}>
                <div style={styles.locationRow}>
                  <div style={styles.dotLine} />
                  <div style={styles.locationText}>
                    <p style={styles.locName}>{b.pickupLocation}</p>
                    <p style={styles.locName}>{b.dropLocation}</p>
                  </div>
                </div>
              </div>

              <div style={styles.infoGrid}>
                <div style={styles.infoItem}>
                  <span style={styles.label}>CUSTOMER</span>
                  <span style={styles.value}>{b.user?.name}</span>
                </div>
                <div style={styles.infoItem}>
                  <span style={styles.label}>VEHICLE</span>
                  <span style={styles.value}>{b.parcelDetails?.vehicleType || "Standard"}</span>
                </div>
              </div>

              <div style={styles.cardFooter}>
                <span style={styles.expiryText}>
                  Ends: {new Date(b.biddingExpiry).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
                <span style={styles.viewLink}>View Details →</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODAL */}
      {isModalOpen && (
        <div style={styles.overlay} onClick={() => setIsModalOpen(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div>
                <h3 style={{ margin: 0 }}>Booking Details</h3>
                <span style={styles.modalSubId}>ID: {selectedBooking?._id || "..."}</span>
              </div>
              <button style={styles.closeBtn} onClick={() => setIsModalOpen(false)}>×</button>
            </div>

            <div style={styles.modalBody}>
              {!selectedBooking ? (
                <div style={{ textAlign: "center", padding: "20px" }}>Fetching details...</div>
              ) : (
                <>
                  <section style={styles.section}>
                    <h4 style={styles.sectionTitle}>Logistics Information</h4>
                    <div style={styles.detailRow}>
                      <span>Route</span>
                      <strong>{selectedBooking.pickupLocation} → {selectedBooking.dropLocation}</strong>
                    </div>
                    <div style={styles.detailRow}>
                      <span>Customer</span>
                      <strong>{selectedBooking.user?.name} ({selectedBooking.user?.phone})</strong>
                    </div>
                  </section>

                  {/*<section style={styles.section}>
                    <h4 style={styles.sectionTitle}>Bidding History</h4>*/}


                  <section style={styles.section}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                      <h4 style={{ ...styles.sectionTitle, marginBottom: 0 }}>Bidding History</h4>
                      <button
                        style={styles.expireBtn}
                        disabled={expiring}
                        onClick={() => handleMarkExpired(selectedBooking._id)}
                      >
                        {expiring ? "Marking..." : "Mark as Expired"}
                      </button>
                    </div>



                    <div style={styles.bidTable}>
                      <div style={styles.bidTableHeader}>
                        <span>DRIVER</span>
                        <span style={{ textAlign: "right" }}>OFFER</span>
                      </div>
                      <div style={styles.bidList}>
                        {bids.length === 0 ? (
                          <div style={styles.noBids}>Waiting for first driver response...</div>
                        ) : (
                          bids.map((bid) => (
                            <div key={bid._id} style={styles.bidRow}>
                              <div style={styles.driverInfo}>
                                <div style={styles.avatar}>{bid.driver?.name?.charAt(0)}</div>
                                <span>{bid.driver?.name}</span>
                              </div>
                              <span style={styles.bidPrice}>₹{bid.amount.toLocaleString()}</span>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </section>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  page: {
    padding: "40px",
    background: "#f8fafc",
    minHeight: "100vh",
    fontFamily: "'Inter', system-ui, sans-serif",
    color: "#1e293b",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "32px",
  },
  title: { fontSize: "28px", fontWeight: "700", margin: 0, letterSpacing: "-0.02em" },
  subtitle: { fontSize: "14px", color: "#64748b", marginTop: "4px" },
  
  refreshBtn: {
    padding: "10px 20px",
    background: "#0f172a",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    cursor: "pointer",
    fontWeight: "600",
    transition: "all 0.2s ease",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
    gap: "24px",
  },

  card: {
    background: "#fff",
    padding: "24px",
    borderRadius: "20px",
    border: "1px solid #e2e8f0",
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    ":hover": { transform: "translateY(-4px)", boxShadow: "0 12px 20px -5px rgba(0,0,0,0.05)" },
  },

  cardTop: { display: "flex", justifyContent: "space-between", marginBottom: "20px" },
  bookingId: { fontSize: "12px", fontWeight: "700", color: "#64748b", background: "#f1f5f9", padding: "4px 10px", borderRadius: "6px" },
  statusBadge: { background: "#e0f2fe", color: "#0369a1", padding: "4px 12px", borderRadius: "20px", fontSize: "11px", fontWeight: "800", textTransform: "uppercase" },

  routeContainer: { marginBottom: "20px", padding: "12px", background: "#f8fafc", borderRadius: "12px" },
  locationRow: { display: "flex", gap: "12px", position: "relative" },
  dotLine: { width: "2px", background: "#cbd5e1", margin: "4px 0", borderRadius: "2px" },
  locationText: { display: "flex", flexDirection: "column", gap: "8px" },
  locName: { fontSize: "13px", fontWeight: "500", margin: 0, color: "#334155" },

  infoGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginBottom: "20px" },
  infoItem: { display: "flex", flexDirection: "column" },
  label: { fontSize: "10px", fontWeight: "700", color: "#94a3b8", marginBottom: "4px" },
  value: { fontSize: "14px", fontWeight: "600" },

  cardFooter: { borderTop: "1px solid #f1f5f9", paddingTop: "15px", display: "flex", justifyContent: "space-between", alignItems: "center" },
  expiryText: { fontSize: "12px", color: "#ef4444", fontWeight: "600" },
  viewLink: { fontSize: "12px", color: "#6366f1", fontWeight: "700" },

  overlay: { position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.75)", backdropFilter: "blur(4px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
  modal: { background: "#fff", width: "480px", borderRadius: "24px", overflow: "hidden", boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)" },
  modalHeader: { padding: "24px", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center" },
  modalSubId: { fontSize: "11px", color: "#94a3b8" },
  closeBtn: { fontSize: "28px", border: "none", background: "none", cursor: "pointer", color: "#94a3b8" },
  
  modalBody: { padding: "24px" },
  section: { marginBottom: "24px" },
  sectionTitle: { fontSize: "12px", fontWeight: "800", textTransform: "uppercase", color: "#94a3b8", marginBottom: "12px", letterSpacing: "0.05em" },
  detailRow: { display: "flex", justifyContent: "space-between", marginBottom: "8px", fontSize: "14px" },

  bidTable: { background: "#f8fafc", borderRadius: "16px", overflow: "hidden", border: "1px solid #e2e8f0" },

    expireBtn: {
    padding: "6px 14px",
    background: "#fee2e2",
    color: "#991b1b",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "12px",
  },

  bidTableHeader: { padding: "12px 16px", background: "#f1f5f9", display: "flex", justifyContent: "space-between", fontSize: "11px", fontWeight: "700", color: "#64748b" },
  bidList: { maxHeight: "200px", overflowY: "auto" },
  bidRow: { padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #e2e8f0" },
  driverInfo: { display: "flex", alignItems: "center", gap: "10px" },
  avatar: { width: "24px", height: "24px", background: "#6366f1", color: "#fff", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", fontWeight: "700" },
  bidPrice: { fontWeight: "700", color: "#10b981" },
  noBids: { padding: "30px", textAlign: "center", fontSize: "13px", color: "#94a3b8" },

  centerScreen: { height: "80vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", color: "#64748b" },
  loader: { width: "40px", height: "40px", border: "3px solid #f3f3f3", borderTop: "3px solid #6366f1", borderRadius: "50%", animation: "spin 1s linear infinite", marginBottom: "16px" },
  emptyCard: { textAlign: "center", padding: "100px", background: "#fff", borderRadius: "20px", border: "2px dashed #e2e8f0", color: "#94a3b8" }
};

export default BiddingBookings;